<template>
  <div class="app">
    <Head></Head>
    <div v-if="isPhone==false">
      <div v-if="isTheme">
        <div class="container">
          <div class="left" id="left">
            <div style="clear: both;"></div>
          </div>
          <div class="right">
            <div class="block1">
              <div class="pic">
                <img alt="xxx" src="../../assets/picshow/imgs/102.png" style="width: 100%;" />
              </div>
            </div>
            <div class="block2">
              <div
                class="text"
              >上汽大众35年不断启程，不断突破，在时代潮流中一步步走向成熟。奋斗在各个岗位的上汽大众人与企业同舟共济，一同成长，留下了无数值得铭记的瞬间。以“我们都是上汽大众人”为主题的图片展讲述了关于上汽大众人的故事，记录了那些关于坚守、拼搏与创新的点滴。</div>
              <div
                class="text-en"
              >Over the past 35 years, SAIC VOLKSWAGEN keeps making breakthroughs and develops by following the trends.Every staff here works together and shares efforts. During this process, numerous magic moments and events are recorded by photos.The photo exhibition "We Are All The People Of SAIC VOLKSWAGEN" presents our stories, and records the details of struggle.</div>
            </div>
            <div class="block3">
              <div class="img" @click="jump()">
                <img alt="xxx" src="../../assets/picshow/imgs/103.gif" />
              </div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
      <div v-if="isTheme==false">
        <Picshow @jumpBack="jumpBack"></Picshow>
      </div>
    </div>
    <PicthemeMobile v-if="isPhone"></PicthemeMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import { getBrowserType, getBrowserHight } from "../../components/js/screen.js";
import Head from "../../components/header-index";
import Foot from "../../components/footer-index";
import PicthemeMobile from "./PicthemeMobile";
import Picshow from "./Picshow";
export default {
  name: "Pictheme",
  components: {
    Head,
    Foot,
    PicthemeMobile,
    Picshow
  },
  data() {
    return {
      isPhone: false,
      isTheme: true
    };
  },
  mounted: function() {
    // 判断是否手机
    this.getIsPhone();
    this.setSectionHeight();
    // 浏览器改变大小监听事件
    window.onresize = this.setSectionHeight;
  },
  methods: {
    setSectionHeight() {
      const h = getBrowserHight();
      const height = `${h}px`;
      document.getElementById("left").style.height = height;
      this.setTitle();
    },
    jump() {
      //this.$router.push({ path: "/picshow" });
      this.isTheme = false;
    },
    jumpBack() {
      this.isTheme = true;
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "我们都是上汽大众人";
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 1px) {
  .container {
    position: relative;
    width: 100%;
  }
  .left {
    position: relative;
    float: left;
    width: 60%;
    background-image: url("../../assets/picshow/imgs/101.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .right {
    position: relative;
    float: right;
    width: 40%;
  }
  .block1 {
    position: relative;
    width: 100%;
    margin-top: 180px;
  }
  .block1 .pic {
    position: relative;
    width: 300px;
    left: 50%;
    margin-left: -150px;
  }
  .block2 {
    position: relative;
    padding: 0 73px;
    margin-top: 50px;
  }
  .block2 .text {
    font-size: 18px;
    color: rgba(32, 32, 32, 1);
    line-height: 30px;
  }
  .block2 .text-en {
    margin-top: 10px;
    font-size: 16px;
    color: rgba(32, 32, 32, 1);
    line-height: 26px;
  }
  .block3 {
    margin-top: 50px;
  }
  .block3 img {
    position: relative;
    width: 222px;
    left: 50%;
    margin-left: -111px;
    cursor: pointer;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .container {
    position: relative;
    width: 100%;
  }
  .left {
    position: relative;
    float: left;
    width: 60%;
    background-image: url("../../assets/picshow/imgs/101.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .right {
    position: relative;
    float: right;
    width: 40%;
  }
  .block1 {
    position: relative;
    width: 100%;
    margin-top: 90px;
  }
  .block1 .pic {
    position: relative;
    width: 190px;
    left: 50%;
    margin-left: -95px;
  }
  .block2 {
    position: relative;
    padding: 0 40px;
    margin-top: 40px;
  }
  .block2 .text {
    font-size: 12px;
    color: rgba(32, 32, 32, 1);
    line-height: 23px;
  }
  .block2 .text-en {
    margin-top: 20px;
    font-size: 11px;
    color: rgba(32, 32, 32, 1);
    line-height: 19px;
  }
  .block3 {
    margin-top: 40px;
  }
  .block3 img {
    position: relative;
    width: 120px;
    left: 50%;
    margin-left: -60px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .container {
    position: relative;
    width: 100%;
  }
  .left {
    position: relative;
    float: left;
    width: 60%;
    background-image: url("../../assets/picshow/imgs/101.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .right {
    position: relative;
    float: right;
    width: 40%;
  }
  .block1 {
    position: relative;
    width: 100%;
    margin-top: 160px;
  }
  .block1 .pic {
    position: relative;
    width: 200px;
    left: 50%;
    margin-left: -100px;
  }
  .block2 {
    position: relative;
    padding: 0 48px;
    margin-top: 40px;
  }
  .block2 .text {
    font-size: 15px;
    color: rgba(32, 32, 32, 1);
    line-height: 28px;
  }
  .block2 .text-en {
    margin-top: 10px;
    font-size: 13px;
    color: rgba(32, 32, 32, 1);
    line-height: 23px;
  }
  .block3 {
    margin-top: 60px;
  }
  .block3 img {
    position: relative;
    width: 184px;
    left: 50%;
    margin-left: -92px;
    cursor: pointer;
  }
}
</style>